import React from 'react';
import Head from '../common/Head'

// Translation
import translate from '../translate/Translate';

// Icons
import * as icons from '../ui/Icons';
import { getParam } from '../../helpers';
import Button from '../common/Button';

const ConfigError = class ConfigError extends React.Component {

  handleErrorMsg() {
    const { store, translation } = this.props;
    const { UserStore } = store;
    const error = getParam('error');
    const signOnError = UserStore.signOnError || getParam('signOnError');

    let errorMsg = '';

    switch(error) {
      case 'domainNotFound':
        errorMsg = translation.error_details[error].replace('%domain%', window.location.origin);
        break;
      case 'pageNotConfigured':
        errorMsg = translation.error_details[error];
        break;
      default:
        errorMsg = translation.error_details[signOnError];
    }

    return errorMsg;
  }

  render() {
    const { store, translation } = this.props;
    const { UserStore } = store;
    const signOnError = UserStore.signOnError || getParam('signOnError');

    return (
      <main
        id="main-content"
        className="page wrap"
        tabIndex="-1"
        aria-labelledby="page-title"
      >
        <Head>
          <title>
            {signOnError === 'userMissing'
              ? `${translation.error_details.userMissing} | SmarterMeasure`
              : `${translation.heading} | SmarterMeasure`
            }
          </title>
        </Head>

        {signOnError !== 'userMissing' &&
          <div className="panel panel--sm panel--solo">
            <i className="panel__icon">
              <icons.lock />
            </i>

            <h1 id="page-title" className="panel__title">
              {translation.heading}
            </h1>

            <h6><strong>{translation.error_details.heading}</strong></h6>

            <code className="code-block">
              {this.handleErrorMsg()}
            </code>
          </div>
        }

        {signOnError === 'userMissing' &&
          <div className="panel panel--sm panel--solo">
            <i className="panel__icon">
              <icons.warningCircle />
            </i>

            <h1 id="page-title" className="panel__title--xs">
              {translation.error_details.userMissing}
            </h1>

            <hr />

            <div style={{ marginTop: '1.5rem' }}>
              <Button
                className="btn btn--primary"
                onClick={() => window.close()}
              >
                {translation.error_details.userMissing_return}
              </Button>
            </div>
          </div>
        }
      </main>
    )
  }
}

export default translate('ConfigError')(ConfigError);
